import { getSnapshot, types } from 'mobx-state-tree'
import { DOMAIN_ACTION } from '@/constants'
import { IValueChange } from '@/pages/supplier/listing/definition/accountDetails'
import { axiosPrivateHelper } from '@/utils/axiosHelper'
const axios = axiosPrivateHelper()

const Options = types.model('Options').props({
  isDraft: types.boolean,
})

const ListModel = types.model('ListModel').props({
  id: types.maybeNull(types.string),
  message: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
})

export const TestimonialsModel = types
  .model('TestimonialsModel')
  .props({
    listing_setup_step: types.optional(types.number, 5),
    testimonials: types.optional(types.array(ListModel), []),
    preValueInput: types.maybeNull(types.optional(ListModel, {})),
    options: types.maybeNull(Options),
    status: types.optional(
      types.enumeration('status', ['changed', 'keep']),
      'keep'
    ),
  })
  .actions((self: any) => {
    const setStatus = (value: 'changed' | 'keep') => {
      self.status = value
    }

    const mapValueChanged = ({
      add,
      value: { testimonials },
    }: IValueChange) => {
      if (add === 'add') {
        self.testimonials = testimonials
        setStatus('changed')
      }
    }

    const mapPrevalueValue = (value: any, options: any = null) => {
      self.preValueInput = value
      self.options = options
    }

    const update = async (id: string, data: any = null) => {
      const prevalue: any = {
        ...getSnapshot(self.preValueInput),
        status: 'submit',
      }
      const isPrevalueCanSave =
        prevalue.message &&
        prevalue.message.length > 0 &&
        prevalue.name &&
        prevalue.name.length > 0

      const URI = `${DOMAIN_ACTION.API.UPDATE_SUPPLIER_LISTING(id)}`
      const remapData = getSnapshot(self.testimonials) as any[]
      const newPayload = remapData.map((item: any) => ({
        ...item,
        status: 'submit',
      }))
      const replaceItemIndex = newPayload.findIndex(
        (item: any) => item.id === self.preValueInput.id
      )
      newPayload[replaceItemIndex] = prevalue
      const payload = {
        listing_setup_step: 5,
        testimonials: !self.options?.isDraft
          ? [...newPayload]
          : isPrevalueCanSave
            ? [...newPayload, prevalue]
            : [...newPayload],
      }

      const { testimonials } = data || { testimonials: [] }
      const paramData = isPrevalueCanSave
        ? [...testimonials, prevalue]
        : [...testimonials]
      const mapData = { ...data, testimonials: paramData }

      const res = await axios.put(URI, data ? mapData : payload)
      return res
    }

    return { setStatus, update, mapValueChanged, mapPrevalueValue }
  })
